import { apiClient } from "@/services/api/axiosClient";
import { API_ENDPOINTS } from "@/services/api/endpoints";

export type ProtestStatus = "submitted" | "inprogress" | "approved" | "rejected" | "pending";

export type Protest = {
  id: string;
  userId: string;
  propertyId: string;
  status: ProtestStatus;
  createdAt: string;
  updatedAt?: string;
  protestYear?: number;
  savings?: number;
  reductionPercentage?: number;
};

export type Milestone = {
  id: string;
  title: string;
  description: string;
  icon: string;
  color: string;
  achieved: boolean;
  achievedAt?: string;
};

export type AchievementsData = {
  active_protest: number;
  completed: number;
  won: number;
  lost: number;
  total_achievement: number;
  protests: Protest[];
  milestones: Milestone[];
  statistics: {
    totalProtests: number;
    completedProtests: number;
    wonProtests: number;
    lostProtests: number;
    totalSavings: number;
    averageReduction: number;
  };
};

type AchievementsResponse = {
  status?: "success" | "error";
  success?: boolean;
  message?: string;
  data?: AchievementsData;
};

export const achievementsService = {
  async getAchievements(): Promise<AchievementsResponse> {
    const { data } = await apiClient.get<AchievementsResponse>(
      API_ENDPOINTS.PROPERTY.USER_ACHIEVEMENT
    );
    return data;
  },
};
